'use client'
import Field from './FormBlock.Field.client'
import styles from './FormBlock.module.scss'
import { classNames } from '@/src/helpers/component'
import SVGInfo from '@/src/components/common/SVG/SVGInfo'

export default function PartnerReferralFormFields() {
  return (
    <>
      <Field
        required
        label={'Business name'}
        input={
          <input
            name={'business_name'}
            type={'text'}
            placeholder={'Business name'}
            autoComplete={'off'}
          />
        }
        className={styles.full}
      />
      <Field
        required
        label={'Business email address'}
        input={
          <input name={'business_email'} type={'email'} placeholder={'Business email address'} />
        }
        className={styles.half}
      />
      <Field
        label={'Business phone'}
        input={
          <input
            name={'business_phone'}
            type={'phone'}
            placeholder={'Business phone'}
            pattern="(0)(4|5)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <Field
        required
        label={`Contact's first name`}
        input={<input name={'contact_first_name'} type={'text'} placeholder={'First name'} />}
        className={styles.half}
      />
      <Field
        label={`Contact's last name`}
        input={<input name={'contact_last_name'} type={'text'} placeholder={'Last name'} />}
        className={styles.half}
      />
      <Field
        required
        label={`Referral's first name`}
        input={<input name={'referree_first_name'} type={'text'} placeholder={'First name'} />}
        className={styles.half}
      />
      <Field
        label={`Referral's last name`}
        input={<input name={'referree_last_name'} type={'text'} placeholder={'Last name'} />}
        className={styles.half}
      />
      <Field
        label={`Referral's email address`}
        input={<input name={'referree_email'} type={'email'} placeholder={'Email address'} />}
        className={styles.half}
      />
      <Field
        required
        label={`Referral's mobile phone`}
        input={
          <input
            name={'referree_mobile_phone'}
            type={'phone'}
            placeholder={'Mobile phone'}
            pattern="(0)(4|5)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <div className={classNames(styles.notice, styles.full)}>
        <SVGInfo color={'#485DAA'} />
        The Partner Referral Program is available to existing contracted businesses with Aunty
        Grace. Terms & Conditions apply.
      </div>
    </>
  )
}
